module.exports = __webpack_public_path__ + "static/media/milhouse.d6f5c679.png";